import { DecimalInput } from '../../../../components/inputs';
import { EditorProps } from '../types/editor-props';

/**
 * Simple decimal input editor for EditableField.
 * Renders a `<DecimalInput>` with the current value, and calls onChange/onBlur as needed.
 * Designed to be used as the default editor for decimal fields in the FieldEditor component,
 * but can also be used standalone when a basic decimal input is sufficient.
 */
export function DecimalEditor({ id, value, onChange, onBlur }: EditorProps) {
  return (
    <DecimalInput
      id={id}
      value={value as string | number | null | undefined}
      onChange={onChange}
      onBlur={onBlur}
      autoFocus
      className='h-8 text-sm'
    />
  );
}
